import { Button, Drawer, DrawerProps, Table, Tooltip } from "antd"
import { useTranslation } from "react-i18next"
import { useAcceptSubstitute, useSubstitutionApplications } from "./queries"
import { ReactComponent as CheckIcon } from "assets/icons/check.svg"

interface Props extends DrawerProps {
  onClose: () => void
  isOpen: boolean
  data?: string
}

const SubstitutionsRequestsDrawer: React.FC<Props> = ({
  data: id,
  ...props
}) => {
  const { t } = useTranslation()
  const { data, isLoading } = useSubstitutionApplications(id)
  const acceptSubstitute = useAcceptSubstitute(id!, {
    meta: {
      type: "accept",
      entity: t("assignations.substitution_request_one"),
      context: "female",
      count: 1,
    },
    onSuccess: () => {
      props.onClose()
    },
  })

  return (
    <Drawer title={t("assignations.substitution_request_other")} {...props}>
      <Table
        columns={[
          {
            title: t("labels.name") as any,
            dataIndex: ["person", "name"],
            key: "name",
          },
          {
            title: t("labels.comment") as any,
            dataIndex: "comment",
            key: "comment",
          },
          {
            title: t("global.actions") as any,
            key: "actions",
            render: (_, record) => (
              <Tooltip title={t("global.accept")}>
                <Button
                  type="text"
                  loading={
                    acceptSubstitute.isLoading &&
                    acceptSubstitute.variables === record.id
                  }
                  disabled={
                    acceptSubstitute.isLoading &&
                    acceptSubstitute.variables !== record.id
                  }
                  onClick={() => acceptSubstitute.mutateAsync(record.id)}
                  icon={<CheckIcon height={12} />}
                />
              </Tooltip>
            ),
          },
        ]}
        dataSource={data}
        loading={isLoading}
        pagination={false}
      />
    </Drawer>
  )
}

export default SubstitutionsRequestsDrawer
